import { catalog } from '@atlassiansox/metal-client';
import { metalClient } from '../client';
import { getPage } from './page-matcher';

/**
 * Reports task successful completion
 * @param task
 */
export const sendSuccessfulMetric = (task: string): void => {
  metalClient.metric.submit({
    task,
    name: catalog.userInteraction.TASK_SUCCESS,
    page: getPage(),
  });
};

/**
 * reports task successful completion in a known time
 * @param task
 * @param timeTaken
 * @param expectedDurationMax
 */
export const sendSuccessfulTimedMetric = (pageName: string, task: string, timeTaken: number): void => {
  sendSuccessfulMetric(task);
  metalClient.metric.submit({
    task,
    name: catalog.userInteraction.TASK_TIME_TO_COMPLETE,
    value: timeTaken,
    page: pageName,
  });
};

export const sendFailureMetric = (task: string): void => {
  metalClient.metric.submit({
    task,
    name: catalog.userInteraction.TASK_FAILURE,
    page: metalClient.currentPage,
  });
};

export const logTimeStamp = (startTime: number, pageName: string, task: string) => {
  const presentTime = new Date().getTime();
  sendSuccessfulTimedMetric(pageName, task, presentTime - startTime);
};
